export default __webpack_public_path__ + "static/media/profile-1.2dd7f1e2.png";